var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing"},[_c('Header'),_c('Container',[_c('SectionGameStory'),_c('SectionGameCommander'),_c('SectionSpaceship'),_c('SectionPlayToEarn'),_c('SectionRoadmap'),_c('SectionScreenShot')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }